module.exports = __webpack_public_path__ + "img/default-img.876e7b84.jpg";